<template>
  <div
    v-if="name"
    class="dg-modal-background"
    @click="clickedAway"
  >
    <div
      class="dg-modal"
      @click.stop
    >
      <component
        :is="name"
        v-bind="otherProps"
      />
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex"
  import AppDetailsModal from "@/components/modals/AppDetailsModal"
  import BuildingSignupsModal from "@/components/modals/BuildingSignupsModal"
  import ContentDetailsModal from "@/components/modals/ContentDetailsModal"
  import DownloadReportsModal from "@/components/modals/DownloadReportsModal"
  import InvitationFormModal from "@/components/modals/InvitationFormModal"
  import InvitationLinkModal from "@/components/modals/InvitationLinkModal"
  import MoveFileModal from "@/components/modals/MoveFileModal"
  import SelectPhotoModal from "@/components/modals/SelectPhotoModal"
  import StripeSetupModal from "@/components/modals/StripeSetupModal"

  // Modals that ignore clicks on the backdrop and close only through their
  // own buttons.
  const PERSISTENT_MODALS = ["InvitationFormModal", "InvitationLinkModal"]

  export default {
    components: {
      AppDetailsModal,
      BuildingSignupsModal,
      ContentDetailsModal,
      DownloadReportsModal,
      InvitationFormModal,
      InvitationLinkModal,
      MoveFileModal,
      SelectPhotoModal,
      StripeSetupModal,
    },
    props: {
      account: {
        default: null,
        required: false,
        type: Object,
      },
      channelId: {
        required: false,
        default: null,
        type: Number,
      },
      content: {
        required: false,
        default: null,
        type: Object,
      },
      contextShare: {
        required: false,
        default: null,
        type: Object,
      },
      initialValues: {
        default: null,
        required: false,
        type: Object,
      },
      modalVariant: {
        default: null,
        required: false,
        type: String,
      },
      name: {
        required: true,
        type: String,
      },
      rallyId: {
        required: false,
        default: null,
        type: Number,
      },
    },
    computed: {
      otherProps() {
        const nonNameProps = Object.assign({}, this.$props)
        delete nonNameProps.name
        return nonNameProps
      }
    },
    methods: {
      ...mapActions("user", ["setModalProps"]),
      clickedAway() {
        // Invite modals hold a form the user may have spent a while on
        // (pasted email lists, a custom message); they close only via their
        // own Cancel/Close buttons, never by clicking outside — a text-
        // selection drag out of the textarea lands here as a click, and on
        // mobile the outside tap is usually just dismissing the keyboard.
        if (PERSISTENT_MODALS.includes(this.name)) { return }
        this.setModalProps({})
      },
    },
  }
</script>
